export interface InputLengthValidation {
  max: number;
  // Can be !error and !valid if a field is empty
  error: boolean;
  valid: boolean;
  showCounter: boolean;
  counter: false | number;
}

export const validateInput = (
  input: string,
  max: number,
  required = true
): InputLengthValidation => {
  const length = input?.length || 0;
  const showCounter = length > max * 0.8;

  return {
    max,
    error: length > max,
    valid: (!required || !!input) && length <= max,
    showCounter,
    counter: showCounter && max
  };
};
